<template>
  <div class="detail_layout">
    <div class="detail_body">
      <div class="detail_body_top">
        <mt-swipe :show-indicators="false">
          <mt-swipe-item v-for="item in detailinfo.picUrls" :key="item">
            <img :src="item" alt="" width="100%" height="100%"/>
          </mt-swipe-item>
        </mt-swipe>
      </div>
      <div class="detail-content-wrap">
        <div class="line"></div>
        <div class="coupon">
          <div class="dashed-line coupon-line"></div>
        </div>
        <div class="detail-content">


          <div class="discount-info">

            <template v-if="detailinfo.goodsName === '京东、天猫电子券各一张'">
              <img class="pic" src="https://www.qq-card.com/gzhimages/banner/jd_A.png">
              <div class="discount-name">京东超市京东E卡</div>
              <div class="discount-amount">
							<span>10</span
              >元
                <div class="discount-count">X 1张</div>
              </div>
              <!-- 添加一个 div 用于增大间距 -->
              <div class="spacer">
                <div class="line"></div>
              </div>

              <img class="pic" src="https://www.qq-card.com/gzhimages/banner/tm_A.png">
              <div class="discount-name">天猫超市电子券</div>
              <div class="discount-amount">
							<span>10</span
              >元
                <div class="discount-count">X 1张</div>
              </div>
            </template>
            <template v-else>

              <img class="pic" :src="detailinfo.profilePicture"/>
              <div class="discount-name">{{ detailinfo.goodsName }}</div>
              <div class="discount-amount">
							<span>{{ detailinfo.cardAmount }}</span
              >元
                <div class="discount-count">X {{ detailinfo.cardNum }}张</div>
              </div>
            </template>


            <div class="actions-btn">
              <div class="btn" @click="toRecordsClick()">
                <span>领用记录</span>
              </div>
              <div
                  class="btn"
                  @click="toUseClick(detailinfo)"
                  :class="{
									'discount-received': detailinfo.useStatus === '1'
								}">
                <span v-if="$route.params.goodsType != 1">{{ detailinfo.useStatus | useBtnText }}</span>
                <span v-else>{{ detailinfo.useStatus | useBtnTe }}</span>
              </div>
            </div>
          </div>
          <div class="dashed-line"></div>
          <div class="discription">
            <div class="section-title">使用说明</div>
            <p class="desc" v-html="contents"></p>
          </div>
        </div>
      </div>
    </div>
    <modal
        :visible="popupVisible"
        title="权益确认"
        :isCancelBtn="true"
        @onCancel="cancelModalClick"
        classStyles="detail_modal">
      <template #modal_body>
        <div>
          <p class="detail_modal_label">您选择的权益为</p>
          <p class="detail_modal_content">
            <span>{{ detailinfo.goodsName }}&nbsp;&nbsp;</span>
            <span>{{ detailinfo.cardNum }}张&nbsp;&nbsp;</span>
            <span>{{ detailinfo.cardAmount }}元</span>
            <span>券</span>
          </p>
          <div class="detail_modal_okbtn" @click.stop="okBtnClick"> 确认使用</div>
          <div class="detail_modal_cancelbtn" @click.stop="cancelModalClick"> 我再想想</div>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import modal from '../../../components/modal.vue'
import {mapState} from 'vuex'
import {handleRequestError} from '@/static/js/common'

export default {
  components: {
    modal
  },
  data() {
    return {
      topimgsrc: '',
      detailinfo: {},
      popupVisible: false,
      id: '',
      outCouponId: ''
    }
  },
  mounted() {
    const id = this.$route.params.id
    console.log(this.$route, 'this.$route')
    const outCouponId = this.$route.params.outCouponId
    this.id = id
    this.outCouponId = outCouponId
    this.getdetail(id, outCouponId)
  },
  computed: {
    ...mapState(['loginInfo']),
    contents() {
      return this.detailinfo.useMethod
    }
  },
  filters: {
    useBtnTe(val) {
      switch (val) {
        case '0':
          return '去激活'

        case '1':
          return '已激活'
        default:
          return '已激活'
      }
    },
    useBtnText(val) {
      switch (val) {
        case '2':
          return '下月使用'
        case '1':
          return '已领取'
        default:
          return '领取'
      }
    }
  },
  methods: {

    /** 获取商品详情 */
    getdetail(id, outCouponId) {

      console.log('goodsId in localStorage:', localStorage.getItem('goodsId'));
      console.log('66', id)
      if (id !== undefined) {
        localStorage.setItem('goodsId', id);
      }


      this.post(this.apis.findGoodsDetail, {

        goodsId: id === undefined ? localStorage.getItem('goodsId') : id,
        memberId: this.loginInfo.id,
        outCouponId,
        spn: localStorage.getItem('spn')
      })
          .then((res) => {
            if (res.data.code === '0') {
              const data = res.data.data
              console.log('77', data)
              if (data.picUrl) {
                data.picUrls = data.picUrl.split(',')
              }
              if (data.useMethod) {
                data.useMethod = data.useMethod.replace(/\n/g, '<br>')
              }
              data.useStatus = data.useStatus.toString()

              this.detailinfo = data
              console.log('222', this.detailinfo)
            }
          })
          .catch((error) => {
            console.log(error)
            handleRequestError(this, error)
          })
    },
    /** 领取 */
    toUseClick(item) {
      console.log('787', item)


      if (item.useStatus !== '1') {
        if (item.goodsType != 1) {
          let spn = localStorage.getItem('spn')
          console.log('spn', spn)
          // const params = {
          //   memberId: this.loginInfo.id,
          //   goodsId: this.id,
          //   outCouponId: this.outCouponId,
          //   spn: localStorage.getItem('spn')
          // }
          console.log("发起领取请求")
          this.get(this.apis.findGoodsRightsCount+"?spn="+spn).then((res) => {
            if (res.data.code === '0') {
              this.popupVisible = true
            } else if (res.data.code === '9999') {
              this.$toast({
                message: res.data.message,
                duration: 1000
              })
            }
          })
              .catch((error) => {
                console.log(error)
                handleRequestError(this, error)
              })
        } else {
          this.popupVisible = true
        }
      }
    },
    toRecordsClick() {
      this.$router.push({
        name: 'couponRecords',
        params: {
          memberId: this.loginInfo.id,
          goodsId: this.detailinfo.goodsId,
          regionNo: this.$route.params.regionNo,
          goodsType: this.$route.params.goodsType
        }
      })
    },
    /** 确认领取 */
    okBtnClick() {
      if (this.$route.params.goodsType == 1) {
        this.exchangeCode2()
      } else {
        this.exchangeCode()
      }

      this.popupVisible = false
    },

    /** 取消 */
    cancelModalClick() {
      this.popupVisible = false
    },
    /** 兑换 */
    exchangeCode2() {
      this.post(this.apis.getCoupon, {
        regionNo: this.$route.params.regionNo,
        num: this.$route.params.num,
        couponId: this.detailinfo.id,
        memberId: this.loginInfo.id,
        productCatalogId: this.detailinfo.id,
        phone: this.loginInfo.mobile,
        cardAmount: this.detailinfo.cardAmount
      })
          .then((res) => {
            if (res.data.code === '0') {
              this.$toast({
                message: '兑换成功',
                duration: 1000
              })
              const id = this.$route.params.id
              const outCouponId = this.$route.params.outCouponId
              this.id = id
              this.outCouponId = outCouponId
              this.getdetail(id, outCouponId)
            } else if (res.data.code === '9999') {
              this.$toast({
                message: res.data.message,
                duration: 1000
              })
            }
          })
          .catch((error) => {
            console.log(error)
            handleRequestError(this, error)
          })
    },
    exchangeCode() {
      this.post(this.apis.couponCreateAndGetCode, {
        regionNo: this.$route.params.regionNo,
        num: this.$route.params.num,
        couponId: this.detailinfo.id,
        memberId: this.loginInfo.id,
        productCatalogId: this.detailinfo.id,
        phone: this.loginInfo.mobile
      })
          .then((res) => {
            if (res.data.code === '0') {
              this.$toast({
                message: '兑换成功',
                duration: 1000
              })
              const id = res.data.data
              this.$router.push({
                name: 'receiveDiscount',
                params: {
                  orderId: id,
                  couponId: this.detailinfo.id,
                  memberId: this.loginInfo.id,
                  goodsId: this.detailinfo.goodsId,
                  regionNo: this.$route.params.regionNo
                }
              })
            } else if (res.data.code === '9999') {
              this.$toast({
                message: res.data.message,
                duration: 1000
              })
            }
          })
          .catch((error) => {
            console.log(error)
            handleRequestError(this, error)
          })
    }
  }
}
</script>
<style scoped lang="less">
.detail_layout {
  width: 100%;
  min-height: 100vh;
  background-color: #f3f3f3;
}

.detail_body {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  &_top {
    width: 100%;
    min-height: 300px;
    height: 380px;
  }
}

.detail_modal {
  // position: relative;
  &_label {
    color: #848484;
    padding: 16px 0px 0px;
  }

  &_content {
    color: #cd0c09;
    font-size: 32px;
    padding: 16px 0px 0px;
    margin: 24px 0px 50px;
  }

  &_okbtn {
    width: 85%;
    margin: 0 auto;
    background-color: #cd0c09;
    border-radius: 40px;
    text-align: center;
    color: #fff;
    line-height: 60px;
    height: 60px;
    margin-top: 16px;
    cursor: pointer;
  }

  &_cancelbtn {
    width: 85%;
    margin: 0 auto;
    text-align: center;
    color: #dcdcdc;
    margin-top: 24px;
    cursor: pointer;
    height: 60px;
    margin-top: 16px;
  }
}

.detail-content-wrap {
  padding: 0 24px;
  margin-top: -168px;
  padding-bottom: 50px;

  .detail-content {
    background: #fff;
    margin: 0 10px;
    margin-top: -2px;

    .discount-info {
      text-align: center;
      border-bottom: 1px dashed #d3d3d3;
      padding-bottom: 50px;
      position: relative;
      z-index: 1;
      background: #fff;

      .pic {
        border-radius: 100%;
        width: 100px;
        height: 100px;
        border: 1px solid #d9d9d9;
        display: block;
        margin: 0 auto;
      }

      .discount-name {
        font-size: 35px;
        margin-top: 16px;
        color: #000000; /* 颜色 */
        font-family: "Alibaba PuHuiTi 2.0", "Alibaba PuHuiTi 20", sans-serif; /* 设置字体 */
        font-weight: normal; /* 字重 */
        font-style: normal; /* 字体样式 */
      }

      .discount-amount {
        color: #f96914;
        flex-shrink: 0;
        display: inline-flex;
        align-items: flex-end;
        justify-content: center;
        font-size: 28px;
        position: relative;
        margin-top: 24px;

        span {
          font-size: 80px;
          line-height: 1;
          font-weight: bold;
        }
      }

      .discount-count {
        width: 90px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #fb7019;
        border-radius: 24px 24px 24px 0px;
        color: #fff;
        font-size: 24px;
        position: absolute;
        right: -108px;
        top: 0;
      }

      .actions-btn {
        display: grid;
        grid-template-columns: repeat(2, 214px);
        gap: 44px;
        justify-content: center;
        margin-top: 36px;

        .btn {
          width: 214px;
          height: 56px;
          line-height: 56px;
          background: #ffffff;
          border-radius: 56px;
          border: 1px solid #fb7019;
          color: #fb7019;
          font-size: 28px;
        }
      }
    }

    .discription {
      padding: 24px 50px;

      .desc {
        font-size: 20px;
        color: #919191;
        line-height: 38px;
      }
    }

    .section-title {
      font-size: 32px;
      margin-bottom: 18px;
      position: relative;
      display: flex;
      align-items: center;

      &::before {
        content: '';
        width: 6px;
        height: 28px;
        background: #fb7019;
        margin-right: 14px;
        display: block;
      }
    }
  }
}

.line {
  height: 4px;
  background: #d9d9d9;
  box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.25);
}

.coupon {
  margin: 0 10px;
  overflow: hidden;
  padding-top: 80px;
  filter: drop-shadow(0 0 0 rgba(0, 0, 0, 0.1));
  position: relative;
  color: #fff;

  &::after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: #fff;
    z-index: -1;
    -webkit-mask: radial-gradient(circle at 20px 61%, transparent 20px, red 0) -20px;
  }

  .coupon-line {
    width: calc(100% - 50px);
    position: absolute;
    left: 25px;
    top: 48px;
  }
}

.dashed-line {
  height: 1px;
  background: repeating-linear-gradient(to right, #d3d3d3, #d3d3d3 6px, transparent 6px, transparent 12px);
}

.spacer {
  height: 80px; /* 设置间距高度 */
  position: relative; /* 相对定位 */
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
}

.line {
  width: 450px;
  height: 0px;
  border: 1px solid #F3F3F3;
}
</style>
